import { useParams } from "react-router-dom";
import { getCategoryBySlug } from "@/constants/categories";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";

/** Resolves /products/:slug to a product detail or category listing. */
export const ProductsRoute = () => {
  const { slug } = useParams<{ slug: string }>();

  if (slug && getCategoryBySlug(slug)) {
    return <ProductsPage />;
  }

  return <ProductDetailPage />;
};

export default ProductsRoute;
